const routes = [
  // {
  //   path: '/ai/index',
  //   name: 'ai-index',
  //   component: () => import('@/views/ai/AIIndex.vue'),
  //   // meta: {
  //   //   title: "AI小科",
  //   // },
  // },
  {
    path: '/ai/dialog',
    name: 'ai-dialog',
    component: () => import('@/views/ai/AIDialog.vue'),
    meta: {
      title: 'AI小科',
    },
  },
  {
    path: '/ai/history',
    name: 'ai-history',
    component: () => import('@/views/ai/AIHistory.vue'),
    meta: {
      title: '会话记录',
    },
  },
];
export default routes;
